import React, { Component } from 'react'
import { Alert, Button, Col, DatePicker, Form, Input, message, Select } from 'antd'
import { strVal } from '../../../../../modules/Utils'
import * as moment from 'moment'
import CountrySelect from '../../../../../elements/Select/Country'
import withLoadingSection from '../../../../../elements/HOC/withLoadingSection'
import { compose } from 'recompose'

const FormItem = Form.Item
const { TextArea } = Input
const Option = Select.Option

class Organisation extends Component {
  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        values['dob'] = values['dob'] instanceof moment ? values['dob'].format('YYYY-MM-DD') : ''
        values['registrationDate'] =
          values['registrationDate'] instanceof moment
            ? values['registrationDate'].format('YYYY-MM-DD')
            : ''

        let member = Object.assign(
          {},
          {
            _id: strVal(this.props, 'member._id'),
            _rev: strVal(this.props, 'member._rev'),
            _key: strVal(this.props, 'member._key'),
          },
          values,
        )
        // message.success('Updated !')
        let results = await this.props.handleSubmit(member)
        results && message.success('Updated !')
        // this.props.member = results
      } else {
        message.error('Invalid')
      }
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { formItemLayout, member, submitting, error } = this.props
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 14,
          offset: 4,
        },
      },
    }
    return (
      <Form layout="vertical" onSubmit={this.handleSubmit}>
        <FormItem label="Name" {...formItemLayout}>
          {getFieldDecorator('fn', {
            initialValue: strVal(member, 'fn'),
            rules: [
              {
                required: true,
                message: "Full Name can't be empty ",
              },
            ],
          })(<Input placeholder="Full Name" />)}
        </FormItem>
        <FormItem label="Trading Name" {...formItemLayout}>
          {getFieldDecorator('tradeName', {
            initialValue: strVal(member, 'tradeName'),
          })(<Input placeholder="Trading Name" />)}
        </FormItem>

        <FormItem label="Website URL" {...formItemLayout}>
          {getFieldDecorator('url', {
            initialValue: strVal(member, 'url'),
          })(<Input placeholder="Website URL" />)}
        </FormItem>

        <FormItem label="Registration" {...formItemLayout}>
          <Col span={8}>
            <FormItem {...formItemLayout}>
              {getFieldDecorator('cob', {
                initialValue: member.cob,
              })(<CountrySelect />)}
            </FormItem>
          </Col>
          <Col span={5}>
            <FormItem {...formItemLayout}>
              {getFieldDecorator('registrationDate', {
                initialValue: member.registrationDate
                  ? moment(member.registrationDate)
                  : member.registrationDate,
              })(<DatePicker placeholder="Registration Date" />)}
            </FormItem>
          </Col>
          <Col span={5}>
            <FormItem {...formItemLayout}>
              {getFieldDecorator('companyno', {
                initialValue: strVal(member, 'companyno'),
              })(<Input placeholder="Company Number" />)}
            </FormItem>
          </Col>
        </FormItem>
        <FormItem label="Profile" {...formItemLayout}>
          {getFieldDecorator('profile', {
            initialValue: strVal(member, 'profile'),
          })(<TextArea placeholder="Profile" rows={4} />)}
        </FormItem>
        <FormItem {...tailFormItemLayout}>
          <Button loading={submitting} type="primary" htmlType="submit">
            Update
          </Button>
          {error.key !== '' ? (
            <Alert
              key={error.key}
              message={error.message === '' ? 'failed!' : error.message}
              type="error"
              closable
            />
          ) : null}
        </FormItem>
      </Form>
    )
  }
}

export default compose(withLoadingSection, Form.create())(Organisation)
